var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckUtaBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 10 7",
    style: {
      enableBackground: "new 0 0 10 7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#141414;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1 Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contact-Window"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-433.000000, -212.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Page-1-Copy-2",
    className: "st0",
    d: "M436.3,218.9l-3.2-3c-0.2-0.2-0.2-0.4,0-0.6l0.6-0.6c0.2-0.2,0.5-0.2,0.6,0l2.2,2.1 l4.9-4.7c0.2-0.2,0.5-0.2,0.6,0l0.6,0.6c0.2,0.2,0.2,0.4,0,0.6l-5.9,5.6C436.8,219,436.5,219,436.3,218.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckUtaBlack);
export default __webpack_public_path__ + "static/media/check-uta-black.19df448027917660fc52ddcb0481acac.svg";
export { ForwardRef as ReactComponent };